<template>
  <div id="dealFlow">
    <div class="opreationBox">
      <el-form
        :inline="true"
        :model="formInline"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="交易状态">
          <el-select
            v-model="formInline.TransferState"
            placeholder="请选择交易状态"
          >
            <el-option
              v-for="item in TransferStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="核销状态">
          <el-select
            v-model="formInline.proofreadState"
            placeholder="请选择核销状态"
          >
            <el-option
              v-for="item in proofreadStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户交易订单号">
          <el-input
            placeholder="请输入商户交易订单号"
            clearable
            v-model="formInline.TradeNo"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="微信付款单号">
          <el-input
            placeholder="请输入微信付款单号"
            clearable
            v-model="formInline.PaymentNo"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="微信名">
          <el-input
            placeholder="请输入微信名"
            clearable
            v-model="formInline.UserName"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="formInline.CreateTime"
            clearable
            value-format="yyyy-MM-dd"
            @change="getRemunerationList"
            type="date"
            placeholder="选择创建时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="handleCurrentChange(1)"
          >查询</el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置</el-button>
        </el-form-item>
        <el-form-item
          label=""
          style="float:right"
        >
          <el-button
            style="width:98px"
            type="primary"
            @click="dialogVisible=true"
          >导入核销</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="remunerationList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          align="center"
          prop="userName"
          label="微信名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amount"
          label="金额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="tradeNo"
          label="商户交易订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="paymentNo"
          label="微信付款单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="交易状态"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in TransferStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.state"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="核销状态"
        >
          <template slot-scope="scope">
            <template v-for="(item,index) in proofreadStateList">
              <span
                :key="index"
                :style="{color:item.color}"
                v-if="item.value==scope.row.proofreadState"
              >{{ item.label}}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.createTime?scope.row.createTime:''}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              plain
            >查看</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      >
      </el-pagination>
    </div>
    <el-dialog
      @close="close"
      title="导入csv文件核销提现记录"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        :on-success="success"
        :action="uploadUrl"
        :headers="{Authorization: accessToken}"
        :multiple="false"
        :auto-upload="false"
        :on-change="uploadChange"
        :on-remove="handleRemove"
        accept=".csv"
        :limit="1"
        :data="{
          name:'flie'}"
        :file-list="fileList"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div
          class="el-upload__tip"
          slot="tip"
        >只能上传csv文件</div>
      </el-upload>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="close">取 消</el-button>
        <el-button
          type="primary"
          @click="submitUpload"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTransferRecords } from 'api/request'
import { SetTableH } from '../../utils/utils'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: true,
      tableH: '250',
      uploadUrl:
        process.env.VUE_APP_BaseAPI + '/api/manager/transferRecords/upload',
      accessToken: 'Bearer ' + window.sessionStorage.getItem('token'),
      formInline: {
        TransferState: -1,
        proofreadState: -1,
        TradeNo: '',
        PaymentNo: '',
        UserName: '',
        CreateTime: ''
      },
      TransferStateList: [
        {
          value: -1,
          label: '全部',
          color: ''
        },
        {
          value: 0,
          label: '失败',
          color: '#f56c6c'
        },
        {
          value: 1,
          label: '成功',
          color: '#67c23a'
        }
      ],
      proofreadStateList: [
        {
          value: -1,
          label: '全部',
          color: ''
        },
        {
          value: 0,
          label: '未核销',
          color: '#f56c6c'
        },
        {
          value: 1,
          label: '核销成功',
          color: '#67c23a'
        }
      ],
      pageObj: {
        total: 0,
        PageIndex: 1,
        PageSize: 10
      },
      remunerationList: [],
      fileList: []
    }
  },
  components: {},
  methods: {
    handleSizeChange(val) {
      this.pageObj.PageSize = val
      this.getRemunerationList()
    },
    handleCurrentChange(val) {
      this.pageObj.PageIndex = val
      this.getRemunerationList()
    },
    async getRemunerationList() {
      let params = {
        PageIndex: this.pageObj.PageIndex,
        PageSize: this.pageObj.PageSize,
        TransferState: this.formInline.TransferState,
        proofreadState: this.formInline.proofreadState,
        TradeNo: this.formInline.TradeNo ? this.formInline.TradeNo : null,
        PaymentNo: this.formInline.PaymentNo ? this.formInline.PaymentNo : null,
        UserName: this.formInline.UserName ? this.formInline.UserName : null,
        CreateTime: this.formInline.CreateTime
          ? this.formInline.CreateTime
          : null
      }
      this.loading = true
      let data = await getTransferRecords(params)
      if (data) {
        this.remunerationList = data.rows
        this.pageObj.total = data.total
        this.loading = false
      }
    },
    reset() {
      for (let key in this.formInline) {
        if (key === 'TransferState' || key === 'proofreadState') {
          this.formInline[key] = -1
        } else {
          this.formInline[key] = ''
        }
      }
      this.handleCurrentChange(1)
    },
    submitUpload() {
      if (this.fileList.length) {
        this.$refs.upload.submit()
      } else {
        this.$message({
          message: '请上传核销文件',
          type: 'warning'
        })
      }
    },
    success(response, file, fileList) {
      if (response.code === 200) {
        this.$message({
          message: response.result,
          type: 'success'
        })
        this.close()
        this.handleCurrentChange(1)
      } else {
        this.fileList = []
        this.$message.error(response.result + '，请重新上传')
      }
    },
    uploadChange(file, fileList) {
      this.fileList = fileList
    },
    handleRemove(file, fileList) {
      this.fileList = []
    },
    close() {
      this.fileList = []
      this.dialogVisible = false
    }
  },
  mounted() {
    SetTableH(this)
  },
  created() {
    this.getRemunerationList()
  }
}
</script>
<style lang='scss'>
#dealFlow {
  height: 100%;
  width: 100%;
  .formBox {
    width: 200px;
  }
  .pageBox {
    margin-top: 20px;
    text-align: right;
  }
  .dialog-footer {
    text-align: center;
  }
  .el-upload {
    display: block;
    margin: 0 auto;
    .el-upload-dragger {
      margin: 0 auto;
      width: 100%;
    }
  }
}
</style>
